var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStream(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9259 17.7007V15.5529C6.9259 14.4478 7.82601 13.5477 8.9311 13.5477H16.9965C18.1015 13.5477 19.0017 14.4478 19.0017 15.5529V17.7007M15.9716 7.77269C15.9716 9.43923 14.617 10.7849 12.9504 10.7849C11.2839 10.7849 9.93816 9.43032 9.93816 7.77269C9.93816 6.11506 11.2839 4.75153 12.9504 4.75153C14.617 4.75153 15.9716 6.10615 15.9716 7.77269Z",
    stroke: "black",
    strokeWidth: 1.91,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.954956 21.2654H24.955M24.955 17.9502H0.954956V6.49828C0.954956 3.44146 3.43249 0.955017 6.49822 0.955017H19.4028C22.4685 0.955017 24.946 3.43255 24.946 6.49828V17.9502H24.955Z",
    stroke: "black",
    strokeWidth: 1.91,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStream);
export default __webpack_public_path__ + "static/media/stream.da71ff6eb21ef5eba12fc62b84811078.svg";
export { ForwardRef as ReactComponent };